import React, {useEffect, useCallback, useState} from 'react';
import styles from  './Shop.module.css';
import { useDispatch, useSelector } from 'react-redux';
import { setBlinkWallet, setPaymentType, setEthSnapshotPrice, setSolSnapshotPrice } from './slices/globalDataSlicer';

function Shop() { 

    const { wallet, isPremium, webWalletApp, walletErrorMsg } = useSelector(state => state.globalData);
    const { prices } = useSelector(state => state.streamCryptoInfo);  
    const dispatch = useDispatch();

    const [snapshotEthPrice, setSnapshotEthPrice] = useState(null);
    const [snapshotSolPrice, setSnapshotSolPrice] = useState(null);

    useEffect(() => {
        if (prices['ETHUSDT']) {
            setSnapshotEthPrice(prices['ETHUSDT']);
        }

        if (prices['SOLUSDT']) {
            setSnapshotSolPrice(prices['SOLUSDT']);
        }
    }, [prices]);

    const convertToETH = useCallback((paymentAmmount) => {        
        const ethAmount = paymentAmmount / snapshotEthPrice;
        return ethAmount;
    }, [snapshotEthPrice]);

    const convertToSOL = useCallback((paymentAmmount) => {        
        const solAmount = paymentAmmount / snapshotSolPrice;
        return solAmount;
    }, [snapshotSolPrice]);

    const disabledStyle = {
        cursor: 'not-allowed',
        pointerEvents: 'none', // Disable all interactions
        opacity: 0.5, // Make it look disabled
    };

    const buy = (plan) => {
        const paymentAmmount = plan === 'M' ? 25.0 : 250.0
        dispatch(setEthSnapshotPrice(convertToETH(paymentAmmount)));
        dispatch(setSolSnapshotPrice(convertToSOL(paymentAmmount)));
        dispatch(setPaymentType(plan));      
    };

    useEffect(()=>{
        dispatch(setBlinkWallet(false));        
        if(!wallet){
            setTimeout(() => {
                dispatch(setBlinkWallet(true));                
              }, 300); 
            setTimeout(() => {
                dispatch(setBlinkWallet(false));                
              }, 5000); 
        }        
    },[dispatch, wallet])

    const currentStyle = !wallet ? disabledStyle : {};
    // const currentStyle = !true ? disabledStyle : {};

    const advantages = [
        'Unlock date ranges beyond 30 days to access the latest data',
        'Stay updated with real-time market prices for the top 200 cryptos',         
        'Explore and experiment with a full range of indicators',        
        'View sentiment metrics for the strategy variations',        
        'Create, save, update, and delete your own strategies',
        'Explore and experiment with all 20 built-in system strategies',
        'Receive precise buy and sell signals based on historical market prices',
        'Unlock unlimited investment registrations'
    ]

    return (
        <div className={styles.main_page}>
            <header className={`${styles.main_header} ${styles.shimmer}`}>
                <h1>Become Premium</h1>
            </header>
            <main>
                <section className={styles.content}>
                    {!wallet && 
                        <div style={{fontSize:'15pt', color:'#ff8200'}}>                            
                            <p>Wallet not connected! Please connect your wallet to continue. If this is your first connection, you’ll receive a 1-day trial.</p>
                        </div>
                    }
                    {isPremium && 
                        <div style={{fontSize:'15pt', color:'#65ff63'}}>                            
                            <p>Each new purchase extends your remaining days</p>
                        </div>
                    }

                    {walletErrorMsg && 
                        <div style={{fontSize:'15pt', color:'#ff8200'}}>                            
                            <p>{walletErrorMsg}</p>
                        </div>
                    }
                    <div style={{ display: 'flex', justifyContent: 'space-between', width: '600px', margin: '0 auto', ...currentStyle }}>
                        <div style={{ border: '1px solid gray', borderRadius: '10px', width: '250px', padding: '20px' }}>
                            <p style={{ fontSize: '30px', margin:'auto' }}>Month</p>
                            <p style={{ fontSize: '25px' }}>$25,00 USD</p>
                            {webWalletApp !== '' ? (
                                wallet !== '' && webWalletApp === 'ethereum' ? (
                                    <div style={{ display: 'flex', alignItems: 'center', justifyContent:'center', paddingBottom:'15px' }}>
                                        <img src="https://s2.coinmarketcap.com/static/img/coins/64x64/1027.png" alt="Metamask Icon" style={{ marginRight: '8px', width:'40px', borderRadius: '50%' }} />
                                        <p style={{ fontSize: '15px' }}>({convertToETH(25.0).toFixed(8)} ETH)</p>
                                    </div>
                                ) : (
                                    <div style={{ display: 'flex', alignItems: 'center', justifyContent:'center', paddingBottom:'15px' }}>
                                        <img src="https://s2.coinmarketcap.com/static/img/coins/64x64/5426.png" alt="Solana Icon" style={{ marginRight: '8px', width:'40px', borderRadius: '50%' }} />
                                        <p style={{ fontSize: '15px' }}>({convertToSOL(25.0).toFixed(8)} SOL)</p>
                                    </div>
                                )
                            ) : (
                                <>
                                    <div style={{ display: 'flex', alignItems: 'center', justifyContent:'center' }}>
                                        <img src="https://s2.coinmarketcap.com/static/img/coins/64x64/1027.png" alt="Metamask Icon" style={{ marginRight: '8px', width:'40px', borderRadius: '50%' }} />
                                        <p style={{ fontSize: '15px' }}>({convertToETH(25.0).toFixed(8)} ETH)</p>
                                    </div>
                                    <div>Or</div>
                                    <div style={{ display: 'flex', alignItems: 'center', justifyContent:'center', paddingBottom:'15px' }}>
                                        <img src="https://s2.coinmarketcap.com/static/img/coins/64x64/5426.png" alt="Solana Icon" style={{ marginRight: '8px', width:'40px', borderRadius: '50%' }} />
                                        <p style={{ fontSize: '15px' }}>({convertToSOL(25.0).toFixed(8)} SOL)</p>
                                    </div>
                                </>
                            )}           
                            <div className={`${styles.button_buy_container} ${styles.button}`} style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center', width: '170px', height: '30px', fontSize: '15pt' }} onClick={()=>buy('M')}>
                                <img src={require('../images/crown.png')} alt="crown" style={{ marginRight: '5px', width: '40px' }} />
                                Go Premium
                            </div>
                        </div>
                        <div style={{ border: '1px solid gray', borderRadius: '10px', width: '250px', padding: '20px' }}>                        
                            <p style={{ fontSize: '30px', margin:'auto' }}>Year<span style={{ fontSize: '15px', color: 'gold' }}> (Save $50,00)</span></p>
                            <p style={{ fontSize: '25px' }}>$250,00 USD</p>

                            { webWalletApp !== '' ? (
                                wallet !== '' && webWalletApp === 'ethereum' ? (
                                    <div style={{ display: 'flex', alignItems: 'center', justifyContent:'center', paddingBottom:'15px' }}>
                                        <img src="https://s2.coinmarketcap.com/static/img/coins/64x64/1027.png" alt="Metamask Icon" style={{ marginRight: '8px', width:'40px', borderRadius: '50%' }} />
                                        <p style={{ fontSize: '15px' }}>({convertToETH(250.0).toFixed(8)} ETH)</p>
                                    </div>
                                ) : (
                                    <div style={{ display: 'flex', alignItems: 'center', justifyContent:'center', paddingBottom:'15px' }}>
                                        <img src="https://s2.coinmarketcap.com/static/img/coins/64x64/5426.png" alt="Solana Icon" style={{ marginRight: '8px', width:'40px', borderRadius: '50%' }} />
                                        <p style={{ fontSize: '15px' }}>({convertToSOL(250.0).toFixed(8)} SOL)</p>
                                    </div>
                                )) : (
                                    <><div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                        <img src="https://s2.coinmarketcap.com/static/img/coins/64x64/1027.png" alt="Metamask Icon" style={{ marginRight: '8px', width: '40px', borderRadius: '50%' }} />
                                        <p style={{ fontSize: '15px' }}>({convertToETH(250.0).toFixed(8)} ETH)</p>
                                    </div><div>Or</div><div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', paddingBottom: '15px' }}>
                                            <img src="https://s2.coinmarketcap.com/static/img/coins/64x64/5426.png" alt="Solana Icon" style={{ marginRight: '8px', width: '40px', borderRadius: '50%' }} />
                                            <p style={{ fontSize: '15px' }}>({convertToSOL(250.0).toFixed(8)} SOL)</p>
                                        </div></>
                                )
                            }  
                            <div className={`${styles.button_buy_container} ${styles.button}`} style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center', width: '170px', height: '30px', fontSize: '15pt' }} onClick={()=>buy('Y')}>
                                <img src={require('../images/crown.png')} alt="crown" style={{ marginRight: '5px', width: '40px' }} />
                                Go Premium
                            </div>
                        </div>                        
                    </div><br/>
                    <div style={{ display: 'flex', justifyContent: 'center' }}>
                        <ul className="tooltip-list">
                            {advantages.map((phrase, index) => (
                                <li key={index}>
                                <i className="bi bi-check-lg" style={{ color:'#00ff00', marginRight: '10px', fontSize:'25pt' }}></i> 
                                <span style={{fontSize:'15pt', textAlign:'left'}}>{phrase}</span> 
                                </li>
                            ))}
                        </ul>
                    </div>   
                    <br/>
                    <div style={{ display: 'flex', justifyContent: 'center', width: '600px', margin: '0 auto' }}>
                        <i className="bi bi-heart-fill" style={{ color:'red', marginRight: '10px', fontSize:'15pt' }}></i> 
                        <span style={{fontSize:'15pt', textAlign:'left'}}>Your support will help this list grow even more.</span>                  
                    </div>
                </section>
            </main>                     
        </div>
    );
}

export default Shop;



  






